var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "block-grid-item" },
    [
      _c("router-link", { attrs: { to: _vm.redirectTo } }, [
        _c("img", {
          staticClass: "block-grid-item__img",
          attrs: {
            src:
              "https://res.cloudinary.com/driveim/image/upload/v1571920817/driveim/apartment.jpg",
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "block-grid-item__content text-xs-center" }, [
          _c(
            "div",
            { staticClass: "block-grid-item__content--compact" },
            [
              _c(
                "v-flex",
                [
                  _c("v-layout", { attrs: { row: "" } }, [
                    _c(
                      "h3",
                      {
                        staticClass:
                          "white--text block-grid-item__content--heading",
                        staticStyle: { display: "block", width: "100%" }
                      },
                      [_vm._v(_vm._s(_vm.apartment.apartment_number))]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.apartment.floor > 0
                    ? _c("div", [
                        _c(
                          "span",
                          {
                            staticClass:
                              "white--text block-grid-item__content--span"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(_vm.lblSetting.blockFloor, {
                                    number: _vm.apartment.floor
                                  })
                                )
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block-grid-item__content--hidden-content pa-2" },
            [
              _c(
                "v-layout",
                {
                  staticClass:
                    "block-grid-item__content--hidden-content--header text-xs-left",
                  attrs: { row: "" }
                },
                [
                  _c("v-flex", [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "white--text block-grid-item__content--heading",
                          staticStyle: { display: "block", width: "100%" }
                        },
                        [_vm._v(_vm._s(_vm.apartment.apartment_number))]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.source.digicode
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "white--text block-grid-item__content--span"
                            },
                            [
                              _c("i", [
                                _vm._v(
                                  "Digiocode: " + _vm._s(_vm.source.digicode)
                                )
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.apartment.floor > 0
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "white--text block-grid-item__content--span"
                            },
                            [
                              _c("i", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(_vm.lblSetting.blockFloor, {
                                      number: _vm.apartment.floor
                                    })
                                  )
                                )
                              ])
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { staticClass: "text-xs-left pa-2" }, [
                !_vm.$route.meta.hide_tenant_info
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("v-icon", { attrs: { color: "white" } }, [
                          _vm._v("person")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "white--text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(_vm.lblSetting.blockNumberOfTenant, {
                                number: _vm.apartment.totalTenant || 0
                              })
                            )
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("v-icon", { attrs: { color: "white" } }, [
                      _vm._v("event")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "white--text" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(_vm.lblSetting.blockNumberOfInprocessEvent, {
                              number: _vm.apartment.totalInProgressTicket || 0
                            })
                          )
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("v-icon", { attrs: { color: "white" } }, [
                      _vm._v("attach_file")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "white--text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(_vm.lblSetting.blockNumberOfDocument, {
                            number: _vm.apartment.totalDocument || 0
                          })
                        ) + "\n            "
                      )
                    ])
                  ],
                  1
                )
              ])
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75912f9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75912f9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/components/block-apartment-item/template.html
// module id = null
// module chunks = 